export type InstallationPricing = {
  finalConnections: ServicePricing;
  fourToNinetyNineFlights: ServicePricing;
  fullService: ServicePricing;
  haulAway: ServicePricing;
  oneToThreeFlights: ServicePricing;
  survey: ServicePricing;
  surveyNoCharge: ServicePricing;
};

export type ServicePricing = {
  serviceTierPricingId: number;
  price: number;
};

const getInstallationServicePricingData = async (
  serviceTierId: number,
  zipcode: string,
  itemNumberId: number
): Promise<InstallationPricing | undefined> => {
  const getPricingDataEndpoint = `/services/installation/pricing/?serviceTierId=${serviceTierId}&zipcode=${zipcode}&itemNumberId=${itemNumberId}`;

  try {
    return fetch(getPricingDataEndpoint)
      .then((result) =>
        result.ok ? result.json<InstallationPricing>() : undefined
      )
      .then((result) => {
        return result;
      });
  } catch (e) {
    return undefined;
  }
};

export default getInstallationServicePricingData;
